export default __webpack_public_path__ + "static/media/hero-img.42f8792a.webp";